import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Loader, Mail, Phone } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const ContactForm = () => {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-8 bg-green-50/50 border border-green-100 rounded-lg text-center animate-in fade-in zoom-in duration-500">
        <h3 className="text-xl font-serif text-green-900 mb-2">Kiitos viestistäsi!</h3>
        <p className="text-green-800 mb-6">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="bg-white hover:bg-green-50 border-green-200 text-green-900">
          Lähetä uusi viesti
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <FormField control={control} name="name" rules={{
        required: "Nimi on pakollinen"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-muted-foreground font-normal">Nimi *</FormLabel>
              <FormControl>
                <Input placeholder="Matti Meikäläinen" {...field} className="border-x-0 border-t-0 border-b border-input px-0 bg-transparent focus-visible:ring-0 focus-visible:border-primary transition-colors h-10" />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "Sähköposti on pakollinen",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Virheellinen sähköpostiosoite"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-muted-foreground font-normal">Sähköposti *</FormLabel>
              <FormControl>
                <Input type="email" placeholder="matti@example.com" {...field} className="border-x-0 border-t-0 border-b border-input px-0 bg-transparent focus-visible:ring-0 focus-visible:border-primary transition-colors h-10" />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <FormField control={control} name="phone" rules={{
        required: "Puhelinnumero on pakollinen"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-muted-foreground font-normal">Puhelinnumero *</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+358 40 1234567" {...field} className="border-x-0 border-t-0 border-b border-input px-0 bg-transparent focus-visible:ring-0 focus-visible:border-primary transition-colors h-10" />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="organization" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-muted-foreground font-normal">Organisaatio / Yritys</FormLabel>
              <FormControl>
                <Input placeholder="Kunta X" {...field} className="border-x-0 border-t-0 border-b border-input px-0 bg-transparent focus-visible:ring-0 focus-visible:border-primary transition-colors h-10" />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="message" render={({
      field
    }) => <FormItem>
            <FormLabel className="text-muted-foreground font-normal">Lyhyt kuvaus tarpeesta</FormLabel>
            <FormControl>
              <Textarea placeholder="Kerro lyhyesti, mistä haluat keskustella..." {...field} className="border-x-0 border-t-0 border-b border-input px-0 bg-transparent focus-visible:ring-0 focus-visible:border-primary transition-colors min-h-[100px] resize-none" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 bg-red-50 border border-red-100 rounded-md text-red-800 text-sm">
          {submitError}
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full md:w-auto min-w-[200px] bg-[hsl(220,45%,15%)] hover:bg-[hsl(220,45%,20%)] text-white h-12 text-base font-medium tracking-wide transition-all">
        {isSubmitting ? <>
            <Loader className="animate-spin mr-2 size-4" />
            Lähetetään...
          </> : "Lähetä viesti"}
      </Button>
    </Form>;
};
export default function KeskustellaankoLisaa() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="yhteystiedot" className="py-24 bg-background relative overflow-hidden" ref={ref}>
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className={`grid grid-cols-1 lg:grid-cols-12 gap-16 items-start transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
          
          <div className="lg:col-span-5 grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="flex flex-col gap-4">
              <div className="relative aspect-[3/4] w-full max-w-md overflow-hidden bg-muted">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1566416/img/heikki3.png" alt="Heikki Vuorinen" className="object-cover w-full h-full md:grayscale hover:grayscale-0 transition-all duration-700" loading="lazy" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1566416/img/heikki3.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1566416/img/heikki3.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1566416/img/heikki3.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1566416/img/heikki3.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1566416/img/heikki3.png" src="https://dialogimediatuotanto.com/wp-content/uploads/2026/06/heikki3.jpeg" />
              </div>
              
              <div className="space-y-2">
                <h3 className="text-2xl font-serif text-foreground">Heikki Vuorinen</h3>
                <p className="text-muted-foreground font-medium">Vastaava tuottaja, Dialogi Mediatuotanto</p>
                <p className="text-muted-foreground/80 text-sm leading-relaxed mt-4">Video-, ääni- ja musiikkituotannot sekä projektien kokonaisvastuu. Heikki vastaa tuotantojen suunnittelusta, toteutuksesta ja siitä, että idea etenee valmiiksi lopputulokseksi.</p>
              </div>
            </div>

            <div className="flex flex-col gap-4">
              <div className="relative aspect-[3/4] w-full max-w-md overflow-hidden bg-muted">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1566416/img/Emilia.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1566416/img/emilia_aarnio.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1566416/img/emilia_aarnio.webp-wvc-sizes" alt="Emilia Aarnio" className="object-cover w-full h-full md:grayscale hover:grayscale-0 transition-all duration-700" loading="lazy" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1566416/img/Emilia.webp" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1566416/img/Emilia.webp" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1566416/img/Emilia.webp" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1566416/img/Emilia.webp" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1566416/img/Emilia.webp" src="https://dialogimediatuotanto.com/wp-content/uploads/2026/06/Emilia.jpg" />
              </div>
              
              <div className="space-y-2">
                <h3 className="text-2xl font-serif text-foreground">Emilia Aarnio</h3>
                <p className="text-muted-foreground font-medium">Sisältötuottaja, Dialogi Mediatuotanto</p>
                <p className="text-muted-foreground/80 text-sm leading-relaxed mt-4">Tarinankerronta, laulunkirjoitus ja sisältöjen ideointi. Emilia tuo projekteihin syvyyttä, luovuutta &nbsp;ja inhimillistä näkökulmaa</p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 lg:pl-8">
            <div className="mb-10">
              <h2 className="text-3xl md:text-4xl font-serif text-foreground mb-4">
                Keskustellaanko lisää?
              </h2>
              <p className="text-muted-foreground text-lg">Kerro lyhyesti ideasta tai tarpeestasi. Katsotaan yhdessä, millainen ratkaisu palvelisi sitä parhaiten.</p>
            </div>

            <FormProvider formId="conversation_form_home" sectionName="contact-section" defaultValues={{
            name: "",
            email: "",
            phone: "",
            organization: "",
            message: ""
          }} validationRules={{
            name: {
              required: true
            },
            email: {
              required: true,
              pattern: "email"
            },
            phone: {
              required: true
            }
          }} submitText="Lähetä viesti" successMessage="Kiitos yhteydenotostasi! Olemme sinuun yhteydessä pian." errorMessage="Viestin lähetys epäonnistui. Yritäthän uudelleen." className="w-full">
              <ContactForm />
            </FormProvider>

            <div className="mt-16 pt-8 border-t border-border grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="flex items-center gap-3 text-muted-foreground hover:text-foreground transition-colors">
                <div className="size-10 rounded-lg bg-muted flex items-center justify-center shrink-0">
                  <Phone className="size-4" />
                </div>
                <div className="flex flex-col">
                  <span className="text-xs uppercase tracking-wider font-medium text-muted-foreground/70">Puhelin</span>
                  <span className="text-sm font-medium">+358445903149</span>
                </div>
              </div>

              <div className="flex items-center gap-3 text-muted-foreground hover:text-foreground transition-colors">
                <div className="size-10 rounded-lg bg-muted flex items-center justify-center shrink-0">
                  <Mail className="size-4" />
                </div>
                <div className="flex flex-col">
                  <span className="text-xs uppercase tracking-wider font-medium text-muted-foreground/70">Sähköposti</span>
                  <span className="text-sm font-medium">info@dialogimediatuotanto.com</span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}